/**
 * Formats a session string to the expected API format (YYYYRS)
 * Handles conversion from "YYYY Regular Session" to "YYYYRS"
 * @param session The session string to format
 * @returns The formatted session string
 */
export function formatSessionCode(session: string): string {
  if (!session) return '';
  
  // If it's already in the right format (e.g., "2025RS"), return it
  if (/^\d{4}RS$/.test(session)) {
    return session;
  }
  
  // If it's in the format "2025 Regular Session", convert it
  if (session.includes('Regular Session')) {
    const year = session.split(' ')[0];
    if (/^\d{4}$/.test(year)) {
      return `${year}RS`;
    }
  }
  
  // For any other format, just return as is
  return session;
}

/**
 * Date formatting utilities
 */

// Format UTC time to Eastern Time
export function formatToEastern(dateStr: string): string {
  const date = new Date(dateStr + 'Z')
  return date.toLocaleString('en-US', { 
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true
  })
}